import { reactive } from "vue";
import { getMe } from "./http";

// Logged-in operator's identity + permissions. Loaded once after auth; read by
// NavMenu (which menus show), the router guard (where they may go), and
// AdminView. A user with zero access (not admin, cannot create accounts, no
// assigned accounts) sees no menus and lands on the no-access page.
export const currentUser = reactive({
  username: null as string | null,
  isAdmin: false,
  canCreateAccount: false,
  accountCount: 0,
  loaded: false,
});

// Can this user see the WeChat account list at all?
export function canViewAccounts(): boolean {
  return currentUser.isAdmin || currentUser.canCreateAccount || currentUser.accountCount > 0;
}

// Does this user have any accessible screen? (false => no-access page)
export function hasAnyAccess(): boolean {
  return currentUser.isAdmin || currentUser.canCreateAccount || currentUser.accountCount > 0;
}

export async function loadMe(): Promise<void> {
  try {
    const res = await getMe();
    if (res.successful && res.result) {
      currentUser.username = res.result.username;
      currentUser.isAdmin = res.result.isAdmin;
      currentUser.canCreateAccount = res.result.canCreateAccount;
      currentUser.accountCount = res.result.accountCount ?? 0;
    }
  } catch {
    /* keep defaults (no elevated access) */
  } finally {
    currentUser.loaded = true;
  }
}
